import request from '@/utils/request'

// 订单列表
export function fetchList(data) {
	return request({
		url: '/oms/userOrder/list',
		method: 'POST',
		data
	})
}

// 订单详情
export function getOrderDetail(orderCode) {
	return request({
		url: '/oms/userOrder/detail',
		method: 'GET',
		params: {
			orderCode
		}
	})
}

// 订单操作
export function updateOrderInfo(data) {
	return request({
		url: '/oms/userOrder/updateConsumerOrder',
		method: 'POST',
		data
	})
}

// 获取地址列表 parentId
export function getRegionList(params = {parentId: 0}) {
	return request({
		url: '/oms/region/queryRegionList',
		method: 'GET',
		params
	})
}

// 修改地址信息
export function editAddress(data) {
	return request({
		url: '/oms/userOrder/updateOrderAddress',
		method: 'POST',
		data
	})
}

// 取消原因列表
export function getCancelReasonList() {
	return request({
		url: '/oms/orderDict/cancelReasonList',
		method: 'GET'
	})
}

// 取消原因列表
export function getReturnReasonList() {
	return request({
		url: '/oms/orderDict/returnReasonList',
		method: 'GET'
	})
}
// /oms/userOrder/return/queryReturnOrderList

// 校验订单合并
export function checkMergeOrder(data) {
	return request({
		url: '/oms/userOrder/checkMergeOrder',
		method: 'POST',
		data
	})
}

// 订单合并
export function mergeOrder(data) {
	return request({
		url: '/oms/userOrder/mergeOrder',
		method: 'POST',
		data
	})
}

// 商品查询
export function searchProduct(params) {
	return request({
		url: '/oms/product/searchProduct',
		method: 'GET',
		params
	})
}

// 新增商品
export function editOrderItem(data) {
	return request({
		url: '/oms/userOrder/saveEditOrderItem',
		method: 'POST',
		data
	})
}

// 退货
export function applyReturnOrder(data) {
	return request({
		url: '/oms/userOrder/return/applyReturnOrder',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/oms/order.js